import { IFormSettings } from '../types/IFormSettings';

export const findControl = (controlName: string, form: IFormSettings) => {
    for (let i = 0; i < form.controls.length; i += 1) {
        const control = form.controls[i];
        if ('fieldSetName' in control) {
            for (let j = 0; j < control.controls.length; j += 1) {
                const currentStepControl = control.controls[j];
                if (currentStepControl.controlName === controlName ||
                    // For controlnames in a repeatable block, since they have a counter in the name (something.[0].something) and never matches the original controlname.
                    (controlName.includes(currentStepControl.controlName) && currentStepControl.type === 'repeatableBlock')) {
                    return currentStepControl;
                }
            }
        }

        if ('controlName' in control && control.controlName === controlName) {
            return control;
        }
    }

    return undefined;
};
